import { render, staticRenderFns } from "./KPIs.vue?vue&type=template&id=15a64d09"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a64d09')) {
      api.createRecord('15a64d09', component.options)
    } else {
      api.reload('15a64d09', component.options)
    }
    module.hot.accept("./KPIs.vue?vue&type=template&id=15a64d09", function () {
      api.rerender('15a64d09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/KPIs.vue"
export default component.exports